module.exports = __webpack_public_path__ + "static/media/pix-logo-cyan.634959a9.svg";